import { ICameraLayer, ICameraLayerCamera } from "../models/Layers";

import DivIconMarker from "./DivIconMarker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon } from "trunx";
import { LatLng, LeafletMouseEvent } from "leaflet";
import config from "../config";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { observer } from "mobx-react-lite";
import {
  cameraOverlapId,
  useMarkerPosition,
} from "../contexts/MarkerOverlapContext";
import { useRootStore } from "../models/Root";

const {
  markers: { camera: cameraColor },
} = config;

const CameraMarker = observer(({ camera }: { camera: ICameraLayerCamera }) => {
  const {
    layers: { baseMap, setCamera, selectedCamera },
  } = useRootStore();

  const position = useMarkerPosition(
    cameraOverlapId(camera.url),
    new LatLng(camera.location.lat, camera.location.lng)
  );
  const eventHandlers = {
    click: (e: LeafletMouseEvent) => {
      setCamera(camera);
    },
  };

  const marker = { position, eventHandlers };

  const color =
    cameraColor || (baseMap.startsWith("Imagery") ? "white" : "black");

  const selected = selectedCamera?.url === camera.url;
  return (
    <DivIconMarker
      key={camera.url}
      marker={marker}
      container={{ tagName: "div" }}
    >
      <Icon
        className={`fa-layers camera-marker${selected ? " is-selected" : ""}`}
      >
        <FontAwesomeIcon icon={faCamera} color={color} size="lg" />
      </Icon>
    </DivIconMarker>
  );
});

export interface CameraLayerProps {
  model: ICameraLayer;
}

const CameraLayer = ({ model: { visible, cameras } }: CameraLayerProps) => {
  if (!visible) {
    return <></>;
  }

  return (
    <>
      {cameras.map((camera) => (
        <CameraMarker key={camera.url} camera={camera} />
      ))}
    </>
  );
};

export default observer(CameraLayer);
